import { atom } from 'recoil';

interface IDrawerOption {
  icon: string;
  path: string;
  label: string;
}

interface IDrawerMenuOption {
  icon: string;
  path: string;
  label: string;
}


export const isDrawerOpen = atom({
  key: 'isDrawerOpen',
  default: true,
});

export const drawerOption = atom<IDrawerOption|null>({
  key: 'drawerOption',
  default: null,
});

export const isDrawerMenuOpen = atom({
  key: 'isDrawerMenuOpen',
  default: true,
});

export const drawerMenuOption = atom<IDrawerMenuOption|null>({
  key: 'drawerMenuOption',
  default: null,
});
